import { Component } from '@angular/core';
import { SeatComponent } from 'src/app/models/components/objectComponents/SeatComponent';
import { BaseAdvancedPropertyViewComponent } from '../base-advanced-property-view.component';
import { getComponentFromSource } from 'src/app/generics-helper/getComponentFromSource.generic';
import { ComponentNames } from 'src/app/helper/componentNames';
import { ArmrestBetweenSeatComponent } from 'src/app/models/components/objectComponents/ArmrestBetweenSeatComponent';
import { AdjustableSeatComponent } from 'src/app/models/components/objectComponents/AdjustableSeatComponent';
import { userHasFeature } from 'src/app/helper/userHasFeature';
import { AuthService } from 'src/app/services/auth.service';
import { FeatureEnum } from 'src/app/models/enums/FeatureEnum';
import { MatDialogRef } from '@angular/material/dialog';
import { InputHelper } from 'src/app/helper/inputHelper';

@Component({
  selector: 'app-seat',
  templateUrl: './seat.component.html',
  styleUrls: ['./seat.component.css']
})
export class AdjustableSeatViewComponent extends BaseAdvancedPropertyViewComponent {
  seat: SeatComponent = new SeatComponent();
  adjustableSeat: AdjustableSeatComponent = new AdjustableSeatComponent();
  armrestBetweenSeat: ArmrestBetweenSeatComponent = new ArmrestBetweenSeatComponent();
  show: boolean = false;
  seatCapacities: number[] = [1, 1.5, 2, 2.5, 3, 3.5, 4, 4.5, 5, 5.5, 6];
  showFeatureSeatFootrest: boolean;
  integerOnly = InputHelper.integerOnly;
  integerOnlyWithNegatives = InputHelper.integerOnlyWithNegatives;

  error = {
    greaterZeroInfo: 'Only values greater zero are valid!',
    minusOneOrW1MaxInfo: 'Only minus one, or values greater zero or equal to w1 are valid!',
    zeroOrH1MaxInfo: 'Only zero and all other values greater or equal to h1 are valid! '
  };

  constructor(private authService: AuthService, public dialogRef: MatDialogRef<BaseAdvancedPropertyViewComponent>) {
    super(dialogRef);
    dialogRef.disableClose = true;
  }

  ngOnInit() {
    this.seat = getComponentFromSource(ComponentNames.seatComponent, this.items);
    this.adjustableSeat = getComponentFromSource(ComponentNames.adjustableSeatComponent, this.items);
    this.armrestBetweenSeat = getComponentFromSource(ComponentNames.armrestBetweenSeatComponent, this.items);
    this.loadFeatures();

  };

  loadFeatures() {
    let tmpShowDoubleSeat = userHasFeature(this.authService.getCurrentFeatures(), FeatureEnum.CanOverrideDoubleSeatFootrest);
    let tmpShowSingleSeat = userHasFeature(this.authService.getCurrentFeatures(), FeatureEnum.CanOverrideSingleSeatFootrest);
    let tmpShowBench = userHasFeature(this.authService.getCurrentFeatures(), FeatureEnum.CanOverrideBenchFootrest);

    if (this.seat.seatAmount == 2 && !this.seat.seatAmountEditable) {
      if (tmpShowDoubleSeat) {
        this.showFeatureSeatFootrest = true;
      }
      else {
        this.showFeatureSeatFootrest = false;
      }
    }
    if (this.seat.seatAmount == 1 && !this.seat.seatAmountEditable) {
      if (tmpShowSingleSeat) {
        this.showFeatureSeatFootrest = true;
      }
      else {
        this.showFeatureSeatFootrest = false;
      }
    }

    if (this.seat.seatAmountEditable) {
      if (tmpShowBench) {
        this.showFeatureSeatFootrest = true;
      }
      else {
        this.showFeatureSeatFootrest = false;
      }
    }
  };

  changeSeatCapacity(selectedValue: number) {
    this.seat.seatAmount = selectedValue;
  };

  saveButtonDisabledState(): boolean {
    let saveDisabled = false;

    // w2 check
    if (!this.getW2ValidState()) {
      saveDisabled = true;
    }

    // w3 check
    if (!this.getW3ValidState()) {
      saveDisabled = true;
    }

    // w4 check
    if (!this.getW4ValidState()) {
      saveDisabled = true;
    }

    // h1 check
    if (!this.getH1ValidState()) {
      saveDisabled = true;
    }

    // h2 check
    if (!this.getH2ValidState()) {
      saveDisabled = true;
    }


    return saveDisabled;
  };

  getW2ValidState() {
    let state = this.adjustableSeat.length85 == -1 || this.adjustableSeat.length85 > 0 && this.adjustableSeat.length85 <= this.baseDimension.box.length;
    return state;
  }

  getW3ValidState() {
    let state = this.adjustableSeat.length60 == -1 || this.adjustableSeat.length60 > 0 && this.adjustableSeat.length60 <= this.baseDimension.box.length;
    return state;
  }

  getW4ValidState() {
    let state = this.adjustableSeat.lengthSeatSurface == -1 || this.adjustableSeat.lengthSeatSurface > 0 && this.adjustableSeat.lengthSeatSurface <= this.baseDimension.box.length;
    return state;
  }

  getH1ValidState() {
    let state = this.baseDimension.box.height != null && this.baseDimension.box.height > 0;
    return state;
  }

  getH2ValidState() {
    let state = this.adjustableSeat.heightLowerEdge != null && this.adjustableSeat.heightLowerEdge >= 0 && this.adjustableSeat.heightLowerEdge <= this.baseDimension.box.height;
    return state;
  }
}
